/**
 * Types of services used for processing txp actions
 */
enum MigrationMode {
    Unknown = 'Unknown',
    Griffin = 'Griffin',
    Utah = 'Utah',
}

export default MigrationMode;
